import { Skeleton } from "@/components/ui/skeleton";

export function InsightsResultsSkeleton() {
  return (
    <div className="flex flex-col flex-1 min-h-0 gap-2 border rounded-lg p-3">
      <Skeleton className="h-4 w-32" />
      <div className="flex flex-col gap-2 flex-1 min-h-[200px]">
        <Skeleton className="h-8 w-full" />
        <Skeleton className="h-8 w-full" />
        <Skeleton className="h-8 w-full" />
        <Skeleton className="h-8 w-3/4" />
      </div>
    </div>
  );
}
